import React from 'react';
import {Row, Col} from 'react-bootstrap';
import {useNavigate} from "react-router-dom";
import {DateDisplay} from "../Extra/DateDisplay";
import {UrlFixer} from "../../utils/utils";
import {StyledNewsItem, StyledNewsItemThumb, StyledNewsItemTitle} from "../../utils/common-styles";

export const HomeNewsItem = (props) => {

    const navigate = useNavigate();
    const newsItem = props.newsItem;

    function clickHandler(id, slug) {
        let url = '/news/' + id + '/' + slug;
        navigate(url);
    }

    return (
        <StyledNewsItem onClick={(e) => clickHandler(newsItem.id, newsItem.slug)}>

            <Row>
                <Col xs={12} md={6}>
                    <StyledNewsItemThumb>
                        <img src={UrlFixer(newsItem.image_details.variations.home_list_item_small)} alt={newsItem.title}/>
                    </StyledNewsItemThumb>
                </Col>
                <Col xs={12} md={6}>
                    <StyledNewsItemTitle>
                        <h5><a href={`/news/${newsItem.id}/${newsItem.slug}`}>{newsItem.title}</a></h5>
                        <ul className="post-meta">
                            <li><span>Posted:</span><DateDisplay datetime={newsItem.published_at}/></li>
                        </ul>
                        <p> {newsItem.intro}</p>
                    </StyledNewsItemTitle>
                </Col>
            </Row>

        </StyledNewsItem>
    )
}